import { Inline, Stack, Text, textVariants } from '@etg/wings';
import { Icon } from '@eti/components';
import { useTranslation } from '@eti/providers';
import { css } from '@eti/styles';
import type { TravelerChoicePricesType } from '../../../models';

const mealChoiceStyles = css`
  margin-inline-start: 26px;
`;

interface PassengerMealProps {
  passengerBoundMeal: NonNullable<TravelerChoicePricesType[number]>;
}

const PassengerBoundMeal = ({ passengerBoundMeal }: PassengerMealProps) => {
  const { t } = useTranslation();

  return (
    <Stack data-testid="passenger-meal" spacing={4}>
      <Inline spacing={8}>
        <Icon data-testid="passenger-info-meal-icon" id="fork-knife-thin" size="20px" />
        <Text data-testid="passenger-info-meal-title" variant={textVariants._14_BOLD}>
          {t('OrderDetails.Passenger.Drawer.Meal.Title')}
        </Text>
      </Inline>
      <Text className={mealChoiceStyles} data-testid="passenger-meal-selection">
        {passengerBoundMeal.choice}
      </Text>
    </Stack>
  );
};

export default PassengerBoundMeal;
